import React, { useState, useEffect } from "react";
import { Form, Row, Col, Modal, Button as But } from "antd";
import CropDown from "../ReportFormGenerator/CropDown/CropDown";
import TextBox from "../ReportFormGenerator/TextBox/TextBox";
import Decimal from "../ReportFormGenerator/Decimal/Decimal";
import MultipleInput from "../ReportFormGenerator/MultipleInput/MultipleInput";
import Date from "../ReportFormGenerator/Date/Date";
import UniDropAdv from "../../components/ReportFormGenerator/UniDrop/UniDropAdv";
import TypSubType from "../../components/ReportFormGenerator/TypSubType/TypSubType";

import RadioPicker from "../ReportFormGenerator/Radio/Radio";
import CheckboxPicker from "../ReportFormGenerator/Checkbox/Checkbox";
import Range from "../ReportFormGenerator/Range/Range";

import Int from "../ReportFormGenerator/Int/Int";
import Button from "../ReportFormGenerator/Button/Button";

import moment from "moment";
import FileController from "../../pages/InputCreater/FileController";
import ImgUpload from "../../pages/InputCreater/ImgUpload";

function FormElement(props) {
  const getElement = (elem, form) => {
    switch (elem.typ) {
      case "textBox":
        return (
          <TextBox
            form={form}
            name={elem._id}
            label=""
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.default ? elem["default"] : null}
            type="input"
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "intControl":
        return (
          <Int
            form={form}
            name={elem._id}
            label=""
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem ? elem["default"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "decimalControl":
        return (
          <Decimal
            form={form}
            name={elem._id}
            labelColSpan={16}
            label=""
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem ? elem["default"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "multiDecimalControl":
      case "multiIntControl":
      case "multiTextControl":
      case "multiDropDownControl":
      case "multiDropDown":
        const input_type =
          elem.typ === 'multiDropDown' ? 'dropdown' :
            elem.typ === "multiDecimalControl"
              ? "decimal"
              : elem.typ === "multiIntControl"
                ? "int"
                : "text";

        return (
          <MultipleInput
            sourceParams={elem.srcParam || {}}
            dropDownData={elem.data}
            pname={elem.pname ? elem.pname : elem._id + "lbl"}
            searchable={elem.searchable || false}
            includeAll={elem.includeAll || false}
            form={form}
            inputType={input_type}
            name={elem._id}
            multiSelect={elem.multiSelect || false}
            labelColSpan={16}
            label=""
            numberOfFields={elem.inputBoxQty}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.dictVal ? elem.dictVal : elem.ans ? elem["ans"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
            minRequired={elem.minRequired ? elem.minRequired : null}
          />
        );
        break;
      case "datePicker":
        return (
          <Date
            form={form}
            format={elem.format ? elem.format : "YYYY-MM-DD"}
            name={elem._id}
            labelColSpan={16}
            label=""
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            // defaultValue={elem ? elem["default"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
            defaultValue={
              elem.default
                ? isNaN(elem.default)
                  ? moment(elem.default).format(
                    elem.format ? elem.format : "YYYY-MM-DD"
                  )
                  : moment()
                    .add(elem.default, "days")
                    .format(elem.format ? elem.format : "YYYY-MM-DD")
                : moment().format(elem.format ? elem.format : "YYYY-MM-DD")
            }
          />
        );
        break;
      case "dateTimePicker":
        return (
          <Date
            form={form}
            format={elem.format ? elem.format : "YYYY-MM-DD HH:mm:ss"}
            name={elem._id}
            labelColSpan={16}
            label=""
            showTime={true}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            // defaultValue={elem ? elem["default"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
            defaultValue={
              elem.default
                ? isNaN(elem.default)
                  ? moment(elem.default).format(
                    elem.format ? elem.format : "YYYY-MM-DD HH:mm:ss"
                  )
                  : moment()
                    .add(elem.default, "days")
                    .format(elem.format ? elem.format : "YYYY-MM-DD HH:mm:ss")
                : moment().format(
                  elem.format ? elem.format : "YYYY-MM-DD HH:mm:ss"
                )
            }
          />
        );
        break;
      case "rangePicker":
        return (
          <Range
            // placeholder={placeHolder ? placeHolder : "Select " + label}
            errorMessage={
              elem.errorMessage ? elem.errorMessage : "Please Select date range"
            }
            minDate={elem.minDate}
            maxDate={elem.maxDate}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            format={elem.format ? elem.format : "YYYY-MM-DD"}
            name={elem._id}
            labelColSpan={16}
            label=""
            // isIST={isIST ? isIST : false}
            defaultValue={
              elem.default && elem.default.length === 2
                ? isNaN(elem.default[0]) && isNaN(elem.default[1])
                  ? [
                    moment(elem.default[0]).format(
                      elem.format ? elem.format : "YYYY-MM-DD"
                    ),
                    moment(elem.default[1]).format(
                      elem.format ? elem.format : "YYYY-MM-DD"
                    ),
                  ]
                  : [
                    elem.default[0]
                      ? moment()
                        .add(elem.default[0], "days")
                        .format(elem.format ? elem.format : "YYYY-MM-DD")
                      : moment().format(
                        elem.format ? elem.format : "YYYY-MM-DD"
                      ),
                    elem.default[1]
                      ? moment()
                        .add(elem.default[1], "days")
                        .format(elem.format ? elem.format : "YYYY-MM-DD")
                      : moment().format(
                        elem.format ? elem.format : "YYYY-MM-DD"
                      ),
                  ]
                : null
            }
          />
        );
        break;
      case "fileControl":
        return (
          <FileController
            data={elem}
            form={form}
            name={elem._id}
            label=""
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.default ? elem["default"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}

          />
        );
      case "imageControl":
        return (
          <ImgUpload
            data={elem}
            form={form}
            name={elem._id}
            label=""
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.default ? elem["default"] : null}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
      case "bool":
        return (
          <RadioPicker
            form={form}
            name={elem._id}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem ? elem["default"] : null}
            options={Object.keys(elem.text).map((key) => {
              return { label: elem.text[key], value: key };
            })}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "radio":
        return (
          <RadioPicker
            className={`${elem.format || 'singleLine'} options-checkbox`}
            form={form}
            name={elem._id}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.data.find(x => x.isChkd === true)?._id}
            options={elem.data.map(x => {
              return { label: x.text, value: x._id, checked: x.isChkd }
            })}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "multiRadio":
        return (
          <RadioPicker
            //  className={`${elem.format || 'singleLine'} options-checkbox`}
            form={form}
            name={elem._id}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.ans?.length ? elem.ans[0] : null}
            options={Object.keys(elem.data).map(x => {
              return { label: elem.data[x], value: x }
            })}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "checkBox":
        return (
          <CheckboxPicker
            className={`${elem.format || 'singleLine'} options-checkbox`}
            form={form}
            name={elem._id}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.ans}
            options={elem.data.map(x => {
              return { label: x.text, value: x._id, checked: x.isChkd }
            })}
            onChange={(value) => { }}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "multiCheckBox":
        return (
          <CheckboxPicker
            // className={`${elem.format || 'singleLine'} options-checkbox`}
            form={form}
            name={elem._id}
            disabled={elem.readOnly ? true : false}
            required={elem.required || elem.req}
            defaultValue={elem.ans}
            options={Object.keys(elem.data).map(x => {
              return { label: elem.data[x], value: x, checked: elem.ans.includes(x) }
            })}
            onChange={(value) => { }}
            errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
          />
        );
        break;
      case "dropDown":
        if (elem.src === "data")
          return (
            <>
              <UniDropAdv
                form={form}
                colSpan={elem.colSpan ? elem.colSpan : 12}
                multiSelect={elem.multiSelect}
                url={elem.url}
                disabled={elem.disabled ? elem.disabled : false}
                source={elem.src}
                options={elem.data}
                extraData={elem.extraData}
                urlData={elem.srcParam ? elem.srcParam : {}}
                pname={elem.pname ? elem.pname : elem._id + "lbl"}
                name={elem._id}
                label={""}
                errorMessage={"Please Select option"}
                required={elem.required || elem.req}
                // placeholder={"Select " + label}
                defaultValue={elem.default ? elem.default : null}
                includeAll={elem.includeAll ? elem.includeAll : false}
                searchable={elem.searchable ? elem.searchable : false}
              />
            </>
          );
        if (elem.src === "dynamic")
          return (
            <>
              <UniDropAdv
                form={form}
                colSpan={elem.colSpan ? elem.colSpan : 12}
                multiSelect={elem.multiSelect}
                url={"/dynamicdropdown"}
                disabled={elem.disabled ? elem.disabled : false}
                source={elem.src}
                options={elem.options}
                extraData={elem.extraData}
                urlData={elem.srcParam ? elem.srcParam : {}}
                pname={elem.pname ? elem.pname : elem._id + "lbl"}
                name={elem._id}
                label={""}
                errorMessage={"Please Select option"}
                required={elem.required || elem.req}
                // placeholder={"Select " + label}
                defaultValue={elem.default ? elem.default : null}
                includeAll={elem.includeAll ? elem.includeAll : false}
                searchable={elem.searchable ? elem.searchable : false}
              />
            </>
          );
        if (elem.src === "mdict")
          return (
            <>
              <UniDropAdv
                form={form}
                colSpan={elem.colSpan ? elem.colSpan : 12}
                multiSelect={elem.multiSelect}
                url={"/mdict"}
                disabled={elem.disabled ? elem.disabled : false}
                source={elem.src}
                // options={elem.options}
                extraData={elem.extraData}
                urlData={elem.srcParam ? elem.srcParam : {}}
                pname={elem.pname ? elem.pname : elem._id + "lbl"}
                name={elem._id}
                label={""}
                errorMessage={"Please Select option"}
                required={elem.required || elem.req}
                // placeholder={"Select " + label}
                defaultValue={elem.default ? elem.default : null}
                includeAll={elem.includeAll ? elem.includeAll : false}
                searchable={elem.searchable || elem.isSearchable}
              />
            </>
          );
        if (elem.src === "cropdown")
          return (
            <>
              <UniDropAdv
                form={form}
                colSpan={elem.colSpan ? elem.colSpan : 12}
                multiSelect={elem.multiSelect}
                url={"/cropdown"}
                disabled={elem.disabled ? elem.disabled : false}
                source={elem.src}
                // options={elem.options}
                extraData={elem.extraData}
                urlData={elem.srcParam ? elem.srcParam : {}}
                pname={elem.pname ? elem.pname : elem._id + "lbl"}
                name={elem._id}
                label={""}
                errorMessage={"Please Select option"}
                required={elem.required || elem.req}
                // placeholder={"Select " + label}
                defaultValue={elem.default ? elem.default : null}
                includeAll={elem.includeAll ? elem.includeAll : false}
                searchable={elem.searchable ? elem.searchable : false}
              />
            </>
          );
        // return (
        //   <DropDown
        //     form={form}
        //     name={elem._id}
        //     disabled={elem.readOnly ? true : false}
        //     required={elem.required || elem.req}
        //     defaultValue={elem ? elem["default"] : null}
        //     errorMessage={elem.errorMessage || elem.msgErr || "invalid!"}
        //     multiSelect={elem.multiSelect ? elem.multiSelect : false}
        //     searchable={true}
        //     options={
        //       elem.data &&
        //       Object.keys(elem.data).map((key) => {
        //         return { label: elem.data[key], value: key };
        //       })
        //     }
        //   />
        // );

        break;
      // <CropDown
      //       url="/cropdown"
      //       urlData={{ name: "TrgVenues" }}
      //       form={form}
      //       name="loc"
      //       label="Venue"
      //       disabled={disabledList.includes("loc")}
      //       errorMessage="Please Select Venue"
      //       required={true}
      //       defaultValue={data ? data["loc"] : null}
      //       placeholder="Select Venue"
      //       searchable={true}
      //     />
      //     <Radio
      //       form={form}
      //       name="assmntReqd"
      //       labelColSpan={16}
      //       label="Supervisor Assessment Required"
      //       disabled={disabledList.includes("assmntReqd")}
      //       required={true}
      //       defaultValue={data ? data["assmntReqd"] : true}
      //       options={[
      //         { label: "Yes", value: true },
      //         { label: "No", value: false },
      //       ]}
      //     />
      //     <Int
      //       form={form}
      //       name="assmntDueDays"
      //       label="Days after Trg for Assessment"
      //       disabled={disabledList.includes("assmntDueDays")}
      //       required={true}
      //       defaultValue={data ? data["assmntDueDays"] : 8}
      //     />
      //     <TextBox
      //       form={form}
      //       type="input"
      //       name="name"
      //       label="Training Name"
      //       required={true}
      //       disabled={disabledList.includes("name")}
      //       errorMessage="Please Select Training Name"
      //       defaultValue={data ? data["name"] : null}
      //       maxChar={400}
      //       maxCharErrorMessage="Accepted only 400 Chars"
      //     />
      //     <Decimal
      //       form={form}
      //       name="trgDurHrs"
      //       label="Duration"
      //       disabled={disabledList.includes("trgDurHrs")}
      //       defaultValue={data ? data["trgDurHrs"] : 4}
      //       required={true}
      //     />
      default:
        break;
    }
  };

  return <>{getElement(props.elemData, props.form)}</>;
}

export default FormElement;
